import { useQuery } from 'react-query';

import { PromptTemplateScope } from '../../../../backend/src/prompt-template/dto/prompt-template.constants';
import { PromptTemplateResponseDto } from '../../../../backend/src/prompt-template/dto/prompt-template.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useGetPromptTemplates = ({
  scope = PromptTemplateScope.Personal,
  enabled = true,
}: {
  scope?: PromptTemplateScope;
  enabled?: boolean;
} = {}) => {
  const fetcher = useFetcher();

  return useQuery<PromptTemplateResponseDto[]>(
    [QueryEntity.PromptTemplates, scope],
    () => fetcher(`${APIBaseChronos}/api/prompt-template?scope=${scope}`),
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );
};
